import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const approveBomTemplateBinding = {
  name: "approveBomTemplateBinding" as const,
  input: z.object({
    bindingId: billOfMaterialsTemplateBindingIdFormat.schema,
    flowKeys: z.array(z.string()).optional(),
    internalOnly: z.boolean().optional(),
  }),
  output: z.object({}),
};
